module.exports = __webpack_public_path__ + "img/LifeChain_Logo.7fc43ab1.png";